import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class Courts extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/courts')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasTrial = option.trials_aggregate.aggregate.count > 0
				// const hasTrialAdm =
				// 	option.trialsAdms_aggregate.aggregate.count > 0
				const hasOriginvara =
					option.trialsByOriginvaraCourtId_aggregate.aggregate.count >
					0
				Object.assign(option, {
					loading: false,
					hasTrial: hasTrial,
					// hasTrialAdm: hasTrialAdm,
					hasOriginvara: hasOriginvara,
				})
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.modalLoading = false
	}

	openEdit(court) {
		this.form.id = court.id
		this.form.name = court.name
		this.$bvModal.show('modal-edit-court')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-court')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const encodedString = encodeURIComponent(this.form.name)
				const name = await api.get(`/api/courts/${encodedString}`)
				if (name.data.length) {
					this.$bvToast.toast(`A 'tramitação' já existe!`, {
						title: 'Alerta!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'warning',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					const court = this.options.find(
						(court) => court.id === this.form.id,
					)
					const res = await api.put(
						'/api/courts/' + court.id,
						this.form,
					)
					if (res.ok) {
						court.name = this.form.name
						this.$bvModal.hide('modal-edit-court')
						this.$bvToast.toast('Tramitação salva com sucesso!', {
							title: 'Sucesso!',
							autoHideDelay: 2500,
							appendToast: true,
							variant: 'success',
							toaster: 'b-toaster-top-center',
							solid: true,
						})
					} else {
						this.$bvToast.toast('Ocorreu um erro inesperado!', {
							title: 'Erro!',
							autoHideDelay: 5000,
							appendToast: true,
							variant: 'danger',
							toaster: 'b-toaster-top-center',
							solid: true,
						})
					}
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const encodedString = encodeURIComponent(this.form.name)
				const name = await api.get(`/api/courts/${encodedString}`)
				if (name.data.length) {
					this.$bvToast.toast(`A 'tramitação' já existe!`, {
						title: 'Alerta!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'warning',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					const res = await api.post('/api/courts/', this.form)
					if (res.ok) {
						this.options.push({
							id: res.id,
							name: this.form.name,
							loading: false,
						})

						// @ts-ignore
						fuse = new Fuse(this.options, {
							keys: ['name'],
						})

						this.$bvModal.hide('modal-new-court')
						this.$bvToast.toast(
							'Tramitação adicionada com sucesso!',
							{
								title: 'Sucesso!',
								autoHideDelay: 2500,
								appendToast: true,
								variant: 'success',
								toaster: 'b-toaster-top-center',
								solid: true,
							},
						)
					} else {
						this.$bvToast.toast('Ocorreu um erro inesperado!', {
							title: 'Erro!',
							autoHideDelay: 5000,
							appendToast: true,
							variant: 'danger',
							toaster: 'b-toaster-top-center',
							solid: true,
						})
					}
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteCourt(court, index) {
		const res = await api.delete('/api/courts/', court)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast('Tramitação excluída com sucesso!', {
				title: 'Sucesso!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'success',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
